module.exports = __webpack_public_path__ + "images/dir-empty-b6a45c9804719ab1c920bbbbc73526de.png";